const EMBED_SESSION_STORAGE_KEY = 'soutien.embedSession'

interface EmbedSessionMarker {
  readonly digest: string
  readonly uid: string
}

const digestOf = async (session: string) => {
  const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(session))
  return Array.from(new Uint8Array(bytes), (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export const isRememberedEmbedSession = async (session: string, uid: string) => {
  try {
    const stored = localStorage.getItem(EMBED_SESSION_STORAGE_KEY)
    if (!stored) {
      return false
    }
    const marker = JSON.parse(stored) as EmbedSessionMarker
    return marker.uid === uid && marker.digest === (await digestOf(session))
  } catch {
    return false
  }
}

export const rememberEmbedSession = async (session: string, uid: string) => {
  try {
    const marker: EmbedSessionMarker = { digest: await digestOf(session), uid }
    localStorage.setItem(EMBED_SESSION_STORAGE_KEY, JSON.stringify(marker))
  } catch {
    // A marker that cannot be stored only costs a fresh piloteSignIn on the next Pilote page.
  }
}
